import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { PdfJsViewerComponent, PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { FluidModule } from "primeng/fluid";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ToastService } from "../../../../services/toast.service";

export interface PdfPreviewDialogConfig {
  fileName: string;
  pdfBytes: Uint8Array | Blob;
}

@Component({
  templateUrl: "./pdf-preview.dialog.html",
  imports: [DialogModule, TranslocoDirective, ButtonModule, FluidModule, PdfJsViewerModule, ProgressSpinnerModule],
})
export class PdfPreviewDialog implements AfterViewInit {
  @ViewChild("pdfViewer") pdfViewer!: PdfJsViewerComponent;

  public pdfBuffer: Uint8Array | Blob;
  public pdfFileName: string;

  constructor(
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig<PdfPreviewDialogConfig>,
    private readonly translocoService: TranslocoService,
    private readonly toastService: ToastService,
  ) {
    if (!this.config.data?.pdfBytes) {
      const error = new Error("PDF bytes were not passed to PDF preview dialog.");
      this.toastService.error(this.translocoService.translate("app.common.errors.unknown"));
      this.ref.close();
      throw error;
    }

    this.pdfFileName = this.config.data.fileName;
    this.pdfBuffer = this.config.data.pdfBytes;
  }

  // Need to do it like this if using blob/Uint8Array as per docs: https://angular-pdf-viewer-docs.vercel.app/docs/faq#-document-loading
  ngAfterViewInit(): void {
    this.pdfViewer.pdfSrc = this.pdfBuffer;
    this.pdfViewer.refresh();
  }
}
